import React, { Component } from 'react';
import './securityFeeds.css';
import CisFeed from './cisFeed/cisFeed.js';

class SecurityFeeds extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="SecurityFeedsPage">
        <CisFeed/>
      </div>
    );

  };

};

export default SecurityFeeds;


// WEBPACK FOOTER //
// ./src/components/content/securityFeeds/securityFeeds.js